var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "inputContainer", class: _vm.invalidClass },
    [
      _c("TheMask", {
        staticClass:
          "placeholder-italic form-input w-full flex-1 block rounded-md sm:text-sm sm:leading-5 focus:shadow-none outline-none focus:outline-none focus:border-primary disabled:bg-input-disabled disabled:border-gray-200 h-input bg-inherit focus:border-primary",
        attrs: {
          value: _vm.value,
          placeholder: "###-###-####",
          mask: "###-###-####",
        },
        on: { input: _vm.handleInput },
        nativeOn: {
          change: function ($event) {
            return _vm.handleChange.apply(null, arguments)
          },
          focus: function ($event) {
            return _vm.handleFocus.apply(null, arguments)
          },
          blur: function ($event) {
            return _vm.handleBlur.apply(null, arguments)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }